module.exports = __webpack_public_path__ + "img/icon-devices.ee552dfa.svg";